<template>
  <div>
    <span class="custom-chip" v-if="searched.number">
      <strong>Nr noty:</strong>&nbsp;{{ searched.number }}
      <span class="close-icon" @click="$emit('updateData', 'number')">
        <v-icon size="18px">fas fa-times-circle</v-icon>
      </span>
    </span>

    <span class="custom-chip" v-if="searched.recipient">
      <strong>Odbiorca:</strong>&nbsp;{{ searched.recipient }}
      <span class="close-icon" @click="$emit('updateData', 'recipient')">
        <v-icon size="18px">fas fa-times-circle</v-icon>
      </span>
    </span>

    <span class="custom-chip" v-if="searched.issued_from">
      <strong>Od:</strong>&nbsp;{{ searched.issued_from }}
      <span class="close-icon" @click="$emit('updateData', 'issued_from')">
        <v-icon size="18px">fas fa-times-circle</v-icon>
      </span>
    </span>

    <span class="custom-chip" v-if="searched.issued_to">
      <strong>Do:</strong>&nbsp;{{ searched.issued_to }}
      <span class="close-icon" @click="$emit('updateData', 'issued_to')">
        <v-icon size="18px">fas fa-times-circle</v-icon>
      </span>
    </span>

    <span class="custom-chip" v-if="searched.payment_method">
      <strong>Płatność:</strong>&nbsp;{{ searched.payment_method }}
      <span class="close-icon" @click="$emit('updateData', 'payment_method')">
        <v-icon size="18px">fas fa-times-circle</v-icon>
      </span>
    </span>

    <span style="display: inline-block; margin-bottom: 10px">
      <button class="btn-search-toggle"
              @click="toggle = !toggle; $emit('toggleSearch', toggle)">
        <v-icon size="15px">fas fa-search</v-icon>
      </button>
      <v-btn color="#555474" class="mt-0 mb-0 mr-0 ml-2"
             @click="$router.push({ name: 'CreateDebitNote' })" dark>
        <v-icon size="15px" class="icon-btn">fas fa-plus</v-icon>&nbsp;Dodaj notę
      </v-btn>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'DebitNoteChips',
    props: {
      searched: Object,
    },
    data() {
      return {
        toggle: false,
      };
    },
  };
</script>
